import { FUTURE_START_DATE, RELATIVE_START_DATE } from 'payments-checkout-lib/constants/LineItems';
import I18n from 'I18n';
import { isSome } from 'payments-checkout-lib/types/utils/helpers';
import { getLineItemRecurringFrequencyBySubtotal } from 'payments-checkout-lib/utils/recurring';
export const getIntervalDescription = (currencyCode, recurringSubtotals) => {
  let intervalDescription = '';
  recurringSubtotals.map(recurringSubtotal => {
    var _initialPayment$relat, _initialPayment$relat2;
    const subtotal = recurringSubtotal === null || recurringSubtotal === void 0 ? void 0 : recurringSubtotal.subtotal;
    const recurringBillingTerms = recurringSubtotal === null || recurringSubtotal === void 0 ? void 0 : recurringSubtotal.recurringBillingTerms;
    const numPayments = recurringBillingTerms === null || recurringBillingTerms === void 0 ? void 0 : recurringBillingTerms.numPayments;
    const initialPayment = recurringBillingTerms === null || recurringBillingTerms === void 0 ? void 0 : recurringBillingTerms.initialPayment;
    const intervalUnit = recurringBillingTerms === null || recurringBillingTerms === void 0 ? void 0 : recurringBillingTerms.intervalUnit;
    const intervalLength = recurringBillingTerms === null || recurringBillingTerms === void 0 ? void 0 : recurringBillingTerms.intervalLength;
    const initialPaymentType = initialPayment === null || initialPayment === void 0 ? void 0 : initialPayment.type;
    const futureStartDate = initialPayment === null || initialPayment === void 0 ? void 0 : initialPayment.futureStartDate;
    const relativeDelayLength = initialPayment === null || initialPayment === void 0 || (_initialPayment$relat = initialPayment.relativeDelay) === null || _initialPayment$relat === void 0 ? void 0 : _initialPayment$relat.delayLength;
    const relativeDelayUnit = initialPayment === null || initialPayment === void 0 || (_initialPayment$relat2 = initialPayment.relativeDelay) === null || _initialPayment$relat2 === void 0 ? void 0 : _initialPayment$relat2.delayUnit;
    const relativeDelayString = relativeDelayUnit && I18n.text(`payments.intervalDescription.rsd.${relativeDelayUnit}`, {
      count: relativeDelayLength
    });
    const formattedFutureStartDate = futureStartDate && I18n.moment.utc(Number(futureStartDate)).format('LL');
    const formattedDateToday = I18n.moment.utc(Date.now()).format('LL');
    const formattedSubtotal = I18n.formatIntlCurrency(subtotal, {
      currencyCode
    });
    const paymentCadence = getLineItemRecurringFrequencyBySubtotal(intervalUnit, intervalLength);
    const paymentString = I18n.text(`payments.intervalDescription.paymentCadence.${paymentCadence}`, {
      subtotal: formattedSubtotal
    });
    const getMessageTranslationKey = () => {
      if (initialPaymentType === FUTURE_START_DATE) {
        return isSome(numPayments) ? 'payments.intervalDescription.fsd.fixedPayments' : 'payments.intervalDescription.fsd.indefinitePayments';
      } else if (initialPaymentType === RELATIVE_START_DATE) {
        return isSome(numPayments) ? 'payments.intervalDescription.rsd.fixedPayments' : 'payments.intervalDescription.rsd.indefinitePayments';
      } else {
        return isSome(numPayments) ? 'payments.intervalDescription.checkout.fixedPayments' : 'payments.intervalDescription.checkout.indefinitePayments';
      }
    };
    intervalDescription += I18n.text(getMessageTranslationKey(), {
      payment: paymentString,
      futureStartDate: formattedFutureStartDate,
      count: numPayments,
      relativeDelay: relativeDelayString,
      dateToday: formattedDateToday
    });
    return intervalDescription;
  });
  // removing the last '.' because Stripe already provides one in the PADs modal
  intervalDescription = intervalDescription.substring(0, intervalDescription.length - 2);
  return intervalDescription;
};